exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.rta_rta_text[data-v-7a783e36] {\n  font-size: 0.78rem;\n}\n", ""]);
